import {
  SHOW_MODAL,
  HIDE_MODAL,
  SHOW_REMOVE_MODAL,
  HIDE_REMOVE_MODAL,
  SHOW_CONFIRM_MODAL,
  HIDE_CONFIRM_MODAL,
  SET_EXPORT_MODAL,
  SET_ALLOW_LIST_MODAL,
  SET_ACCESS_CODE_MODAL
} from '@/state/mutationTypes'
import i18n from '../internatinalization/i18n'
import api from '@/axiosConfig'
const gemnoteAPI = api()

export const modalStore = {
  namespaced: true,
  state: {
    showModal: false,
    showConfirmModal: false,
    activeModals: [],
    isExportModalActive: false,
    isAllowListModalActive: false,
    isAccessCodeModalActive: false
  },
  getters: {
    activeModals: state => modalName => {
      let isModalActive = state.activeModals.find(
        modal => modal.name === modalName
      )

      if (!isModalActive) {
        return false
      }

      return true
    }
  },
  mutations: {
    [SHOW_MODAL](state) {
      state.showModal = true
    },
    [HIDE_MODAL](state) {
      state.showModal = false
    },
    [SHOW_REMOVE_MODAL](state, payload) {
      let { activeModals } = state

      if (activeModals.length) {
        let modalExists = state.activeModals.find(
          modal => modal.name === payload
        )

        if (!modalExists) {
          activeModals.unshift({ name: payload })
        }
      } else {
        activeModals.unshift({ name: payload })
      }

      state.activeModals = [...activeModals]
    },
    [HIDE_REMOVE_MODAL](state, payload) {
      let { activeModals } = state
      activeModals = activeModals.filter(modal => modal.name !== payload)
      state.activeModals = [...activeModals]
    },
    [SHOW_CONFIRM_MODAL](state) {
      state.showConfirmModal = true
    },
    [HIDE_CONFIRM_MODAL](state) {
      state.showConfirmModal = false
    },
    [SET_EXPORT_MODAL](state, value) {
      state.isExportModalActive = value
    },
    [SET_ALLOW_LIST_MODAL](state, value) {
      state.isAllowListModalActive = value
    },
    [SET_ACCESS_CODE_MODAL](state, value) {
      state.isAccessCodeModalActive = value
    }
  },
  actions: {
    showModal({ commit }, modalData) {
      commit(SHOW_MODAL, modalData)
    },
    hideModal({ commit }) {
      commit(HIDE_MODAL)
    },
    showConfirmModal({ commit }) {
      commit(SHOW_CONFIRM_MODAL)
    },
    hideConfirmModal({ commit }) {
      commit(HIDE_CONFIRM_MODAL)
    },
    showRemoveModal({ commit }, modalName) {
      commit(SHOW_REMOVE_MODAL, modalName)
    },
    hideRemoveModal({ commit }, modalName) {
      commit(HIDE_REMOVE_MODAL, modalName)
    },
    setExportModal({ commit }, value) {
      commit(SET_EXPORT_MODAL, value)
    },
    setAllowListModal({ commit }, value) {
      commit(SET_ALLOW_LIST_MODAL, value)
    },
    setAccessCodeModal({ commit }, value) {
      commit(SET_ACCESS_CODE_MODAL, value)
    },

    async handleExports({ commit, dispatch }, route) {
      try {
        await gemnoteAPI.post(`exports/${route}`)
        commit(SET_EXPORT_MODAL, true)
      } catch (error) {
        let errors = []
        if (error.response) {
          if (error.response.status === 500 || error.response.status === 404) {
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: [
                  error.response.status === 500
                    ? i18n.t('server.server-error')
                    : i18n.t('server.not-found')
                ]
              },
              { root: true }
            )
          } else {
            let { errors } = error.response.data
            dispatch(
              'notification/pushNotification',
              {
                type: 'error',
                messages: errors
              },
              { root: true }
            )
          }
        } else if (error.request) {
          errors.push(i18n.t('server.no-response'))
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        } else {
          errors.push(i18n.t('Exporting data failed'))
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      }
    }
  }
}
